import { HeaderNavigation } from 'baseui/header-navigation';
import { useStyles } from '../../hooks/useStyles';
import { PageTitle } from '../dashboard/PageTitle';

type Props = Readonly<{
  children?: React.ReactNode;
}>;

function NavbarWrapper({ children }: Props) {
  const { theme } = useStyles();

  return (
    <HeaderNavigation
      overrides={{
        Root: {
          style: {
            paddingTop: theme.sizing.scale500,
            paddingRight: theme.sizing.scale500,
            paddingBottom: theme.sizing.scale500,
            paddingLeft: theme.sizing.scale500,
            columnGap: theme.sizing.scale500,
            alignItems: 'center',
            minHeight: '60px',
            boxSizing: 'border-box',
          },
        },
      }}
    >
      <PageTitle />
      {children}
    </HeaderNavigation>
  );
}

export default NavbarWrapper;
